<template>

    <v-stepper v-model="step" vertical>
        <v-stepper-header>
            <v-stepper-step color="secondary" :complete="step > 1" step="1">Step 1</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step color="secondary" :complete="step > 2" step="2">Step 2</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step color="secondary" :complete="step > 3" step="3">Step 3</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step color="secondary" :complete="step > 4" step="4">Step 4</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
            
            <v-stepper-content step="1">
                
                <v-form data-vv-scope="form1">
                    <h3>What kind of Contract do you need?</h3>
                    <v-select class="black--text" label="Contract Type" v-model="contract.type" :items="contract_types" v-validate="'required'" :error-messages="errors.collect('form1.Contract Type')" data-vv-name="Contract Type" v-on:change="contract.subtype = null"></v-select>
                  
                    <v-select v-if="contract.type == 'Multimedia Services Agreement'" label="Duration of the Contract" v-model="contract.subtype" v-validate="'required'" :error-messages="errors.collect('form1.Duration of the Contract')" data-vv-name="Duration of the Contract" :items="multimedia_subtypes"></v-select>
                    
                    <v-select v-else-if="contract.type == 'Performance Agreement'" label="Duration of the Contract" v-model="contract.subtype" v-validate="'required'" :error-messages="errors.collect('form1.Duration of the Contract')" data-vv-name="Duration of the Contract" :items="performance_subtypes"></v-select>

                    <v-select v-else-if="contract.type == 'Vendor Service Agreement'" label="Duration of the Contract" v-model="contract.subtype" v-validate="'required'" :error-messages="errors.collect('form1.Duration of the Contract')" data-vv-name="Duration of the Contract" :items="vendor_subtypes"></v-select>
                        
                        <v-radio-group v-else-if="contract.type == 'Speaking Engagement Agreement'" v-model="speaker_less_than_600">
                            <h3>Is the Speaker fee $600 or less?</h3>
                            <v-radio label="Yes" value="y"></v-radio>
                            <v-radio label="No" value="n"></v-radio>
                        </v-radio-group>

                        <v-radio-group v-if="speaker_less_than_600 === 'n'" v-model="speaker_reimburse">
                            <h3>Does the speaker request reimbursements?</h3>
                            <v-radio label="Yes" value="y"></v-radio>
                            <v-radio label="No" value="n"></v-radio>
                        </v-radio-group>
                        
                    <v-btn class="black--text" color="primary" @click="validateStep(2, 'form1')">Next</v-btn>
                </v-form>
            
            </v-stepper-content>

            <v-stepper-content step="2">
                <v-form data-vv-scope="form2_1">
                <v-container v-if="contract.type === types.MULTIMEDIA && contract.subtype === subtypes.MULTIMEDIA_SINGLE_USE">
                    <h3>{{ this.contract.type }} - {{ this.contract.subtype }}</h3>
                    <v-dialog ref="effective_date_dialog" v-model="modal" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="Effective Date" v-model="contract.effective_date" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_1.Effective Date')" data-vv-name="Effective Date"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.effective_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.effective_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    <v-dialog ref="end_date_dialog" v-model="end_modal" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="End Date" v-model="contract.end_date" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_1.End Date')" data-vv-name="End Date"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.end_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.end_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    <v-dialog ref="service_date_dialog" v-model="service_modal" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="Date of Services to be performed" v-model="contract.date_of_service" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_1.Date of Services to be performed')" data-vv-name="Date of Services to be performed"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.date_of_service" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.service_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
           
                    <v-text-field label="Name of Vendor" v-model="contract.vendor_name" v-validate="'required'" :error-messages="errors.collect('form2_1.Name of Vendor')" data-vv-name="Name of Vendor"></v-text-field>
                    <v-text-field label="Vendor Address" v-model="contract.vendor_address" v-validate="'required'" :error-messages="errors.collect('form2_1.Vendor Address')" data-vv-name="Vendor Address"></v-text-field>
                    <v-text-field label="Location of Services to be performed" v-model="contract.location" v-validate="'required'" :error-messages="errors.collect('form2_1.Location of Services to be performed')" data-vv-name="Location of Services to be performed"></v-text-field>
                    <v-text-field label="Description of Services to be performed" v-model="contract.description_of_service" v-validate="'required'" :error-messages="errors.collect('form2_1.Description of Services to be performed')" data-vv-name="Description of Services to be performed"></v-text-field>
                    <v-textarea label="Total fee for services described" v-model="contract.service_fee" v-validate="'required'" hint="If the Vendor has provided a Fee Schedule/Rate Card, it will need to be attached separately when you forward the Agreement to the Vendor." persistent-hint="true" :error-messages="errors.collect('form2_1.Total Fee')" data-vv-name="Total Fee"></v-textarea>
                    
                    
                    <h3>Fee Type</h3>
                    <v-radio-group v-model="contract.fee_type">
                        <v-radio label="Flat (one time payment)" value="flat"></v-radio>
                        <v-radio label="Hourly" value="hourly"></v-radio>
                    </v-radio-group>

                    <v-btn class="black--text" color="primary" @click="step = 1">Previous</v-btn>
                    <v-btn class="black--text" color="primary" @click="validateStep(3, 'form2_1')">Next</v-btn>
                </v-container>
                </v-form>
            
                <v-form data-vv-scope="form2_2">
                <v-container v-if="contract.type === types.MULTIMEDIA && contract.subtype === subtypes.MULTIMEDIA_ACADEMIC_YEAR">
                    <h3>{{ this.contract.type }} - {{ this.contract.subtype }}</h3>
                    <v-dialog ref="effective_date_dialog" v-model="modal" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="Effective Date" v-model="contract.effective_date" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_2.Effective Date')" data-vv-name="Effective Date"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.effective_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.effective_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    <v-text-field label="Name of Vendor" v-model="contract.vendor_name" v-validate="'required'" :error-messages="errors.collect('form2_2.Name of Vendor')" data-vv-name="Name of Vendor"></v-text-field>
                    <v-text-field label="Vendor Address" v-model="contract.vendor_address" v-validate="'required'" :error-messages="errors.collect('form2_2.Vendor Address')" data-vv-name="Vendor Address"></v-text-field>
                    <v-textarea label="Total fee for services described" v-model="contract.service_fee" hint="If the Vendor has provided a Fee Schedule/Rate Card, it will need to be attached separately when you forward the Agreement to the Vendor." persistent-hint="true" v-validate="'required'" :error-messages="errors.collect('form2_1.Total Fee')" data-vv-name="Total Fee"></v-textarea>
                    
                    
                    <h3>Fee Type</h3>
                    <v-radio-group v-model="contract.fee_type">
                        <v-radio label="Flat (one time payment)" value="flat"></v-radio>
                        <v-radio label="Hourly" value="hourly"></v-radio>
                    </v-radio-group>
                    <v-btn class="black--text" color="primary" @click="step = 1">Previous</v-btn>
                    <v-btn class="black--text" color="primary" @click="validateStep(3, 'form2_2')">Next</v-btn>
                </v-container>
                </v-form>
                <v-form data-vv-scope="form2_3">
                <v-container v-if="contract.type === types.PERFORMANCE && contract.subtype === subtypes.PERFORMANCE_SINGLE_USE">
                    <h3>{{ this.contract.type }} - {{ this.contract.subtype }}</h3>
                    <v-dialog ref="effective_date_dialog" v-model="modal" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="Effective Date" v-model="contract.effective_date" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_3.Effective Date')" data-vv-name="Effective Date"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.effective_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.effective_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    <v-dialog ref="presentation_date_dialog" v-model="modal2" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="Date of Performance" v-model="contract.performance_date" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_3.Date of Performance')" data-vv-name="Date of Performance"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.performance_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.presentation_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    <v-text-field label="Performance Time" v-model="contract.performance_time" v-mask="mask"></v-text-field>
                    <v-text-field label="Performer Name" v-model="contract.vendor_name" v-validate="'required'" :error-messages="errors.collect('form2_3.Performer Name')" data-vv-name="Performer Name"></v-text-field>
                    <v-text-field label="Performer Address" v-model="contract.vendor_address" v-validate="'required'" :error-messages="errors.collect('form2_3.Performer Address')" data-vv-name="Performer Address"></v-text-field>
                    <v-text-field label="Name of Performance" v-model="contract.performance_name" v-validate="'required'" :error-messages="errors.collect('form2_3.Name of Performance')" data-vv-name="Name of Performance"></v-text-field>
                    <v-text-field label="Length of Performance" v-model="contract.performance_length" v-validate="'required'" :error-messages="errors.collect('form2_3.Length of Performance')" data-vv-name="Length of Performance"></v-text-field>
                    <v-text-field label="Location of Performance" v-model="contract.location" v-validate="'required'" :error-messages="errors.collect('form2_3.Location of Performance')" data-vv-name="Location of Performance"></v-text-field>
                    <v-text-field label="Performer's Agent" v-model="contract.agent_name" v-validate="'required'" :error-messages="errors.collect('form2_3.Performer Agent')" data-vv-name="Performer Agent"></v-text-field>
                    <v-text-field label="Performer's Fee" v-model="contract.performer_fee" v-currency="{currency: 'USD', distractionFree: false}" v-validate="'required'" :error-messages="errors.collect('form2_3.Performer Fee')" data-vv-name="Performer Fee"></v-text-field>

                    <v-btn class="black--text" color="primary" @click="step = 1">Previous</v-btn>
                    <v-btn class="black--text" color="primary" @click="validateStep(3, 'form2_3')">Next</v-btn>
                </v-container>
                </v-form>

                <v-form data-vv-scope="form2_4">
                <v-container v-if="contract.type === types.PERFORMANCE && contract.subtype === subtypes.PERFORMANCE_ACADEMIC_YEAR">
                    <h3>{{ this.contract.type }} - {{ this.contract.subtype }}</h3>
                    <v-dialog ref="effective_date_dialog" v-model="modal" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="Effective Date" v-model="contract.effective_date" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_4.Effective Date')" data-vv-name="Effective Date"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.effective_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.effective_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    <v-text-field label="Performer Name" v-model="contract.vendor_name" v-validate="'required'" :error-messages="errors.collect('form2_4.Performer Name')" data-vv-name="Performer Name"></v-text-field>
                    <v-text-field label="Performer Address" v-model="contract.vendor_address" v-validate="'required'" :error-messages="errors.collect('form2_4.Performer Address')" data-vv-name="Performer Address"></v-text-field>
                    <!-- <v-text-field label="Name of Performance" v-model="contract.performance_name"></v-text-field> -->
                    <v-text-field label="Type of Performance" v-model="contract.performance_type" v-validate="'required'" :error-messages="errors.collect('form2_4.Type of Performance')" data-vv-name="Type of Performance"></v-text-field>
                    <v-text-field label="Length of Performance" v-model="contract.performance_length" v-validate="'required'" :error-messages="errors.collect('form2_4.Length of Performance')" data-vv-name="Length of Performance"></v-text-field>
                    <v-text-field label="Performer's Agent" v-model="contract.agent_name" v-validate="'required'" :error-messages="errors.collect('form2_4.Performer Agent')" data-vv-name="Performer Agent"></v-text-field>
                    <v-textarea label="Performer's Fee" v-model="contract.performer_fee" hint="If the Performer has provided a Fee Schedule/Rate Card, it will need to be attached separately when you forward the Agreement to the Vendor." persistent-hint="true" v-validate="'required'" :error-messages="errors.collect('form2_4.Fee')" data-vv-name="Fee"></v-textarea>

                    <v-btn class="black--text" color="primary" @click="step = 1">Previous</v-btn>
                    <v-btn class="black--text" color="primary" @click="validateStep(3, 'form2_4')">Next</v-btn>
                </v-container>
                </v-form>

                <v-form data-vv-scope="form2_5">
                <v-container v-if="contract.type === types.PROF_SERVICES">
                    <h3>{{ this.contract.type }}</h3>
                    <v-dialog ref="effective_date_dialog" v-model="modal" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="Effective Date" v-model="contract.effective_date" prepend-icon="event" readonly v-on="on" v-valdiate="'required'" :error-messages="errors.collect('form2_5.Effective Date')" data-vv-name="Effective Date"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.effective_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.effective_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    <v-dialog ref="end_date_dialog" v-model="end_modal" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="End Date" v-model="contract.end_date" prepend-icon="event" readonly v-on="on" v-valdiate="'required'" :error-messages="errors.collect('form2_5.Effective Date')" data-vv-name="Effective Date"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.end_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.end_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    <v-text-field label="Name of Service Provider" v-model="contract.vendor_name" v-validate="'required'" :error-messages="errors.collect('form2_5.Name of Service Provider')" data-vv-name="Name of Service Provider"></v-text-field>
                    <v-text-field label="Service Provider Address" v-model="contract.vendor_address" v-validate="'required'" :error-messages="errors.collect('form2_5.Service Provider Address')" data-vv-name="Service Provider Address"></v-text-field>
                    <!-- <v-text-field label="Type of Service Provided" v-model="contract.service_type" v-validate="'required'" :error-messages="errors.collect('form2_5.Type of Service Provided')" data-vv-name="Type of Service Provided"></v-text-field> -->
                    
                    <v-text-field label="Key Personnel to be Assigned" v-model="contract.vendor_rep" v-validate="'required'" :error-messages="errors.collect('form2_5.Service Provider Rep')" data-vv-name="Service Provider Rep"></v-text-field>
                    <v-textarea label="Description of Service to be Provided" v-model="contract.description_of_service" hint="Please include a description of the services to be provided, any project assumptions and conditions, key tasks and milestones, and any deliverables with any applicable acceptance criteria.  If there is a scope of work or proposal which describes the service to be provided, it should be incorporated by specific reference (title and date of proposal) and separately attached as Exhibit A-1." persistent-hint="true" v-validate="'required'" :error-messages="errors.collect('form2_5.Description of Service')" data-vv-name="Description of Service"></v-textarea>
                    <!-- <v-text-field label="Key Tasks and Project Milestones" v-model="contract.service_tasks" v-validate="'required'" :error-messages="errors.collect('form2_5.Key Tasks and Project Milestones')" data-vv-name="Key Tasks and Project Milestones"></v-text-field>
                    <v-text-field label="Deliverables and Acceptance Criteria" v-model="contract.service_deliverables" v-validate="'required'" :error-messages="errors.collect('form2_5.Deliverables and Acceptance Criteria')" data-vv-name="Deliverables and Acceptance Criteria"></v-text-field> -->
                    <v-text-field label="Estimated Timeline to Perform Services" v-model="contract.estimated_timeline" v-validate="'required'" :error-messages="errors.collect('form2_5.Estimated Timeline')" data-vv-name="Estimated Timeline"></v-text-field>
                    <v-text-field label="Financial Terms" v-model="contract.financial_terms" v-validate="'required'" :error-messages="errors.collect('form2_5.Financial Terms')" data-vv-name="Financial Terms"></v-text-field>

                    <v-btn class="black--text" color="primary" @click="step = 1">Previous</v-btn>
                    <v-btn class="black--text" color="primary" @click="validateStep(3, 'form2_5')">Next</v-btn>
                </v-container>
                </v-form>

                <v-form data-vv-scope="form2_6">
                <v-container v-if="contract.type === types.SPEAKING_ENGAGMEMENT && speaker_less_than_600 === 'y'">
                    <h3>{{ this.contract.type }}</h3>
                    <v-text-field label="Name of Speaker" v-model="contract.vendor_name" v-validate="'required'" :error-messages="errors.collect('form2_6.Name of Speaker')" data-vv-name="Name of Speaker"></v-text-field>
                    <v-dialog ref="presentation_date_dialog" v-model="modal" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="Date of Presentation" v-model="contract.performance_date" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_6.Date of Presentation')" data-vv-name="Date of Presentation"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.performance_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.presentation_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    
                    <v-text-field label="Name of Presentation" v-model="contract.presentation_name" v-validate="'required'" :error-messages="errors.collect('form2_6.Name of Presentation')" data-vv-name="Name of Presentation"></v-text-field>
                    <v-text-field label="Address of Speaker" v-model="contract.vendor_address" v-validate="'required'" :error-messages="errors.collect('form2_6.Address of Speaker')" data-vv-name="Address of Speaker"></v-text-field>
                    <v-text-field label="Audience of Presentation" v-model="contract.speaker_audience_type" v-validate="'required'" :error-messages="errors.collect('form2_6.Audience of Presentation')" data-vv-name="Audience of Presentation"></v-text-field>
                    <v-text-field label="School Sponsoring Speaker" v-model="contract.speaker_sponsor" v-validate="'required'" :error-messages="errors.collect('form2_6.School Sponsoring Speaker')" data-vv-name="School Sponsoring Speaker"></v-text-field>
                    <v-text-field label="Total Compensation to Speaker" v-model="contract.performer_fee" v-currency="{currency: 'USD', distractionFree: false}" v-validate="'required'" :error-messages="errors.collect('form2_6.Total Compensation to Speaker')" data-vv-name="Total Compensation to Speaker"></v-text-field>
                    <v-text-field label="Account Number to be Charged" v-model="contract.account_to_charge" v-validate="'required'" :error-messages="errors.collect('form2_6.Account Number to be Charged')" data-vv-name="Account Number to be Charged"></v-text-field>

                    <v-btn class="black--text" color="primary" @click="step = 1">Previous</v-btn>
                    <v-btn class="black--text" color="primary" @click="validateStep(3, 'form2_6')">Next</v-btn>
                </v-container>
                </v-form>

                <v-form data-vv-scope="form2_7">
                <v-container v-if="contract.type === types.SPEAKING_ENGAGMEMENT && speaker_less_than_600 === 'n' && speaker_reimburse === 'y'">
                    <h3>{{ this.contract.type }}</h3>
                    <v-dialog ref="effective_date_dialog" v-model="modal" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="Effective Date" v-model="contract.effective_date" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_7.Effective Date')" data-vv-name="Effective Date"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.effective_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.effective_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    <v-dialog ref="presentation_date_dialog" v-model="modal2" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="Date of Presentation" v-model="contract.performance_date" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_7.Date of Presentation')" data-vv-name="Date of Presentation"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.performance_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.presentation_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>

                    <v-text-field label="Name of Speaker" v-model="contract.vendor_name" v-validate="'required'" :error-messages="errors.collect('form2_7.Name of Speaker')" data-vv-name="Name of Speaker"></v-text-field>
                    <v-text-field label="Address of Speaker" v-model="contract.vendor_address" v-validate="'required'" :error-messages="errors.collect('form2_7.Address of Speaker')" data-vv-name="Address of Speaker"></v-text-field>
                    <v-text-field label="Name of Presentation" v-model="contract.presentation_name" v-validate="'required'" :error-messages="errors.collect('form2_7.Name of Presentation')" data-vv-name="Name of Presentation"></v-text-field>
                    <v-text-field label="Total Compensation to Speaker" v-model="contract.performer_fee" v-currency="{currency: 'USD', distractionFree: false}" v-validate="'required'" :error-messages="errors.collect('form2_7.Speaker Compensation')" data-vv-name="Speaker Compensation"></v-text-field>
                    <v-text-field label="Location of Speaking Engagement" v-model="contract.location" v-validate="'required'" :error-messages="errors.collect('form2_7.Location of Speaking Engagement')" data-vv-name="Location of Speaking Engagement"></v-text-field>
                    <v-text-field label="Duration of Speaking Engagement" v-model="contract.speaker_duration" v-validate="'required'" :error-messages="errors.collect('form2_7.Duration of Speaking Engagement')" data-vv-name="Duration of Speaking Engagement"></v-text-field>

                    <v-btn class="black--text" color="primary" @click="step = 1">Previous</v-btn>
                    <v-btn class="black--text" color="primary" @click="validateStep(3, 'form2_7')">Next</v-btn>
                </v-container>
                </v-form>

                <v-form data-vv-scope="form2_6">
                <v-container v-if="contract.type === types.SPEAKING_ENGAGMEMENT && speaker_less_than_600 === 'n' && speaker_reimburse === 'n'">
                    <h3>{{ this.contract.type }}</h3>
                    <v-text-field label="Name of Speaker" v-model="contract.vendor_name" v-validate="'required'" :error-messages="errors.collect('form2_8.Name of Speaker')" data-vv-name="Name of Speaker"></v-text-field>
                    <v-text-field label="Address of Speaker" v-model="contract.vendor_address" v-validate="'required'" :error-messages="errors.collect('form2_8.Address of Speaker')" data-vv-name="Address of Speaker"></v-text-field>
                    <v-dialog ref="effective_date_dialog" v-model="modal" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="Effective Date" v-model="contract.effective_date" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_8.Effective Date')" data-vv-name="Effective Date"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.effective_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.effective_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    <v-dialog ref="presentation_date_dialog" v-model="modal2" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="Date of Presentation" v-model="contract.performance_date" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_8.Date of Presentation')" data-vv-name="Date of Presentation"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.performance_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.presentation_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    <v-text-field label="Name of Presentation" v-model="contract.presentation_name" v-validate="'required'" :error-messages="errors.collect('form2_8.Name of Presentation')" data-vv-name="Name of Presentation"></v-text-field>
                    <v-text-field label="Total Compensation to Speaker" v-model="contract.performer_fee" v-currency="{currency: 'USD', distractionFree: false}" v-validate="'required'" :error-messages="errors.collect('form2_8.Speaker Compensation')" data-vv-name="Speaker Compensation"></v-text-field>
                    <v-text-field label="Location of Speaking Engagement" v-model="contract.location" v-validate="'required'" :error-messages="errors.collect('form2_8.Location of Speaking Engagement')" data-vv-name="Location of Speaking Engagement"></v-text-field>
                    <v-text-field label="Duration of Speaking Engagement" v-model="contract.speaker_duration" v-validate="'required'" :error-messages="errors.collect('form2_8.Duration of Speaking Engagement')" data-vv-name="Duration of Speaking Engagement"></v-text-field>
                    
                    <v-btn class="black--text" color="primary" @click="step = 1">Previous</v-btn>
                    <v-btn class="black--text" color="primary" @click="validateStep(3, 'form2_8')">Next</v-btn>
                   
                </v-container>
                </v-form>

                <v-form data-vv-scope="form2_9">
                <v-container v-if="contract.type === types.VENDOR_SERVICES && contract.subtype === subtypes.VENDOR_SERVICE_LEVEL1_NO_INSURANCE">
                    <h3>{{ this.contract.type }} - {{ this.contract.subtype }}</h3>
                    <v-dialog ref="effective_date_dialog" v-model="modal" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="Effective Date" v-model="contract.effective_date" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_9.Effective Date')" data-vv-name="Effective Date"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.effective_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.effective_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    <v-text-field label="Name of Vendor" v-model="contract.vendor_name" v-validate="'required'" :error-messages="errors.collect('form2_9.Name of Vendor')" data-vv-name="Name of Vendor"></v-text-field>
                    <v-text-field label="Vendor Address" v-model="contract.vendor_address" v-validate="'required'" :error-messages="errors.collect('form2_9.Vendor Address')" data-vv-name="Vendor Address"></v-text-field>
                    <v-text-field label="Location of Services to be Performed" v-model="contract.location" v-validate="'required'" :error-messages="errors.collect('form2_9.Location of Services to be Performed')" data-vv-name="Location of Services to be Performed"></v-text-field>
                    <v-text-field label="Description of Services to be performed" v-model="contract.description_of_service" v-validate="'required'" :error-messages="errors.collect('form2_9.Description of Services to be Performed')" data-vv-name="Description of Services to be Performed"></v-text-field>
                    <v-text-field label="Total Fee for services described" v-model="contract.service_fee" v-validate="'required'" :error-messages="errors.collect('form2_9.Total Fee')" data-vv-name="Total Fee"></v-text-field>

                    <v-btn class="black--text" color="primary" @click="step = 1">Previous</v-btn>
                    <v-btn class="black--text" color="primary" @click="validateStep(3, 'form2_9')">Next</v-btn>

                </v-container>
                </v-form>

                <v-form data-vv-scope="form2_10">
                <v-container v-if="contract.type === types.VENDOR_SERVICES && contract.subtype === subtypes.VENDOR_SERVICE_REPEAT_ACADEMIC_YEAR">
                    <h3>{{ this.contract.type }} - {{ this.contract.subtype }}</h3>
                    <v-dialog ref="effective_date_dialog" v-model="modal" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="Effective Date" v-model="contract.effective_date" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_10.Effective Date')" data-vv-name="Effective Date"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.effective_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.effective_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    <v-text-field label="Name of Vendor" v-model="contract.vendor_name" v-validate="'required'" :error-messages="errors.collect('form2_10.Name of Vendor')" data-vv-name="Name of Vendor"></v-text-field>
                    <v-text-field label="Vendor Address" v-model="contract.vendor_address" v-validate="'required'" :error-messages="errors.collect('form2_10.Vendor Address')" data-vv-name="Vendor Address"></v-text-field>
                    <v-text-field label="Location of Services to be Performed" v-model="contract.location" v-validate="'required'" :error-messages="errors.collect('form2_10.Location of Services to be Performed')" data-vv-name="Location of Services to be Performed"></v-text-field>

                    <v-text-field label="Description of Services to be Performed" v-model="contract.description_of_service" v-validate="'required'" :error-messages="errors.collect('form2_10.Description of Services to be Performed')" data-vv-name="Description of Services to be Performed"></v-text-field>
                    <v-text-field label="Total Fee for services Described" v-model="contract.service_fee" v-validate="'required'" :error-messages="errors.collect('form2_10.Total Fee')" data-vv-name="Total Fee"></v-text-field>

                    <v-btn class="black--text" color="primary" @click="step = 1">Previous</v-btn>
                    <v-btn class="black--text" color="primary" @click="validateStep(3, 'form2_10')">Next</v-btn>
                </v-container>
                </v-form>

                <v-form data-vv-scope="form2_11">
                <v-container v-if="contract.type === types.VENDOR_SERVICES && contract.subtype === subtypes.VENDOR_SERVICE_SINGLE_NO_INSURANCE">
                    <h3>{{ this.contract.type }} - {{ this.contract.subtype }}</h3>
                    <v-dialog ref="effective_date_dialog" v-model="modal" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="Effective Date" v-model="contract.effective_date" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_11.Effective Date')" data-vv-name="Effective Date"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.effective_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.effective_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    <v-text-field label="Name of Vendor" v-model="contract.vendor_name" v-validate="'required'" :error-messages="errors.collect('form2_11.Name of Vendor')" data-vv-name="Name of Vendor"></v-text-field>
                    <v-text-field label="Vendor Address" v-model="contract.vendor_address" v-validate="'required'" :error-messages="errors.collect('form2_11.Vendor Address')" data-vv-name="Vendor Address"></v-text-field>
                    <v-text-field label="Location of Services to be Performed" v-model="contract.location" v-validate="'required'" :error-messages="errors.collect('form2_11.Location of Services to be Performed')" data-vv-name="Location of Services to be Performed"></v-text-field>
                    <div>
                        <v-dialog ref="service_date_dialog" v-model="service_modal" :return-value.sync="date" persistent lazy full-width width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field label="Date of Services to be Performed" v-model="contract.date_of_service" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_11.Date of Services to be Performed')" data-vv-name="Date of Services to be Performed"></v-text-field>
                            </template>
                            <v-date-picker v-model="contract.date_of_service" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="$refs.service_date_dialog.save(date)">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </div>
                    <v-text-field label="Description of Services to be Performed" v-model="contract.description_of_service" v-validate="'required'" :error-messages="errors.collect('form2_11.Description of Services to be Performed')" data-vv-name="Description of Services to be Performed"></v-text-field>
                    <v-text-field label="Total Fee for Services Described" v-model="contract.service_fee" v-validate="'required'" :error-messages="errors.collect('form2_11.Total Fee')" data-vv-name="Total Fee"></v-text-field>

                    <v-btn class="black--text" color="primary" @click="step = 1">Previous</v-btn>
                    <v-btn class="black--text" color="primary" @click="validateStep(3, 'form2_11')">Next</v-btn>
                    
                </v-container>
                </v-form>

                <v-form data-vv-scope="form2_12">
                <v-container v-if="contract.type === types.VENDOR_SERVICES && contract.subtype === subtypes.VENDOR_SERVICE_SINGLE_INSURANCE">
                    <h3>{{ this.contract.type }} - {{ this.contract.subtype }}</h3>
                    <v-dialog ref="effective_date_dialog" v-model="modal" :return-value.sync="date" persistent lazy full-width width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="Effective Date" v-model="contract.effective_date" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_12.Effective Date')" data-vv-name="Effective Date"></v-text-field>
                        </template>
                        <v-date-picker v-model="contract.effective_date" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="$refs.effective_date_dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                    <v-text-field label="Name of Vendor" v-model="contract.vendor_name" v-validate="'required'" :error-messages="errors.collect('form2_12.Name of Vendor')" data-vv-name="Name of Vendor"></v-text-field>
                    <v-text-field label="Vendor Address" v-model="contract.vendor_address" v-validate="'required'" :error-messages="errors.collect('form2_12.Vendor Address')" data-vv-name="Vendor Address"></v-text-field>
                    <v-text-field label="Location of Services to be Performed" v-model="contract.location" v-validate="'required'" :error-messages="errors.collect('form2_12.Location of Services to be Performed')" data-vv-name="Location of Services to be Performed"></v-text-field>
                    <div>
                        <v-dialog ref="service_date_dialog" v-model="service_modal" :return-value.sync="date" persistent lazy full-width width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field label="Date of Services to be Performed" v-model="contract.date_of_service" prepend-icon="event" readonly v-on="on" v-validate="'required'" :error-messages="errors.collect('form2_12.Date of Services to be Performed')" data-vv-name="Date of Services to be Performed"></v-text-field>
                            </template>
                            <v-date-picker v-model="contract.date_of_service" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="$refs.service_date_dialog.save(date)">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </div>
                    <v-text-field label="Description of Services to be Performed" v-model="contract.description_of_service" v-validate="'required'" :error-messages="errors.collect('form2_12.Description of Services to be Performed')" data-vv-name="Description of Services to be Performed"></v-text-field>
                    <v-text-field label="Total Fee for Services Described" v-model="contract.service_fee" v-validate="'required'" :error-messages="errors.collect('form2_12.Total Fee')" data-vv-name="Total Fee"></v-text-field>

                    <v-btn class="black--text" color="primary" @click="step = 1">Previous</v-btn>
                    <v-btn class="black--text" color="primary" @click="validateStep(3, 'form2_12')">Next</v-btn>
                </v-container>
                </v-form>

            </v-stepper-content>

            <v-stepper-content step="3">

                <v-container>
                    <h3>Review completed contract here.</h3>
                    <div v-html="this.contract_html"></div>
                    
                    <v-btn class="black--text" color="primary" @click="step = 2">Previous</v-btn>
                    <v-btn class="black--text" color="primary" @click="validateStep(4)">Next</v-btn>
                </v-container>
            </v-stepper-content>

            <v-stepper-content step="4">
                <v-form data-vv-scope="form_email">
                    
                <v-container>
                    <h3>What do you want to do?</h3>
                    <v-snackbar v-model="display_msg">
                        {{ this.response_msg }}
                        <v-btn class="black--text" color="primary" @click="display_msg = false">Close</v-btn>
                    </v-snackbar>
                    <v-radio-group v-model="handle_contract">
                        <v-radio label="Download Contract" value="download_contract"></v-radio>
                        <v-radio label="Email to Vendor" value="email_contract"></v-radio>
                    </v-radio-group>
                   
                    <v-text-field v-if="handle_contract === 'email_contract'" label="Vendor Contact Name" v-model="vendor_contact_name" v-validate="'required'" :error-messages="errors.collect('form_email.Vendor Contact Name')" data-vv-name="Vendor Contact Name"></v-text-field>
                    <v-text-field v-if="handle_contract === 'email_contract'" label="Vendor Email" v-model="email" v-validate="'required'" :error-messages="errors.collect('form_email.Vendor Email')" data-vv-name="Vendor Email"></v-text-field>
                    <v-text-field v-if="handle_contract === 'email_contract'" label="Your Email" v-model="from_email" v-validate="'required'" :error-messages="errors.collect('form_email.Your Email')" data-vv-name="Your Email"></v-text-field>
                    <v-text-field v-if="handle_contract === 'email_contract'" label="Your Name" v-model="from_name" v-validate="'required'" :error-messages="errors.collect('form_email.Your Name')" data-vv-name="Your Name"></v-text-field>
                    <v-container v-if="handle_contract === 'email_contract'">
                        A copy of this contract will also be emailed to you.
                    </v-container>
                    
                    <v-btn class="black--text" color="primary" @click="step=3">Previous</v-btn>
                    <v-btn class="black--text" v-if="handle_contract === 'email_contract'" color="primary" @click="sendContract('form_email')">Send</v-btn>
                    <v-btn class="black--text" v-else color="primary" @click="downloadContract">Download</v-btn>
                </v-container>
                </v-form>
            </v-stepper-content>

        </v-stepper-items>

    <!-- {{ user }} {{ contract }} {{ speaker_less_than_600 }} {{ speaker_reimburse }} -->
    </v-stepper>

</template>


<script>
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import axios from 'axios'
import FileSaver from 'file-saver'
import { mask } from 'vue-the-mask'


const types = {
    MULTIMEDIA: 'Multimedia Services Agreement',
    PERFORMANCE: 'Performance Agreement',
    PROF_SERVICES: 'Professional Services Agreement',
    SPEAKING_ENGAGMEMENT: 'Speaking Engagement Agreement',
    VENDOR_SERVICES: 'Vendor Service Agreement'
}

const subtypes = {
    MULTIMEDIA_SINGLE_USE: 'Single Use Agreement Form',
    MULTIMEDIA_ACADEMIC_YEAR: 'Academic Year Agreement Form',
    PERFORMANCE_SINGLE_USE: 'Single Use Agreement Form', 
    PERFORMANCE_ACADEMIC_YEAR: 'Multiple Engagements over Annual Year',
    GUEST_SPEAKER_INFO: 'Guest Speaker Info Form (under $600)',
    GUEST_SPEAKER_FLAT: 'Speaking Engagement Agreement Form (Flat Fee)', 
    GUEST_SPEAKER_REIMB: 'Speaking Engagement K (Contract) Form - with exp reimb',
    VENDOR_SERVICE_LEVEL1_NO_INSURANCE: 'Repeat Use (No Insurance Required)', 
    VENDOR_SERVICE_REPEAT_ACADEMIC_YEAR: 'Repeat Use (Insurance Required)', 
    VENDOR_SERVICE_SINGLE_NO_INSURANCE: 'Single Use (No Insurance Required)', 
    VENDOR_SERVICE_SINGLE_INSURANCE: 'Single Use (Insurance Required)'
}

export default {

    props: {
        username: String
    },


    data: () => {
        return {
            valid: true,
            step: 1,
            contract: {
                type: null,
                
                subtype: null,
                

                vendor_name: null,
                vendor_address: null,
                vendor_rep: null,
                effective_date: null,
                end_date: null,
                date_of_service: null,
                location: null,
                description_of_service: null,
                service_fee: null,
                service_type: null,
                fee_type: 'flat',
                service_tasks: null,
                service_personnel: null,
                service_deliverables: null,
                estimated_timeline: null,
                financial_terms: null,


                performer_name: null,
                performance_type: null,
                performance_date: null,
                performance_time: null,
                performer_address: null,
                performance_location: null,
                agent_name: null,
                performance_length: null,
                performer_fee: null,

                speaker_audience_type: null,
                speaker_sponsor: null,
                account_to_charge: null,
                speaker_duration: null


            },

            types: types,
            subtypes: subtypes,
            // contract_types: ['Multimedia Services Agreement', 'Performance Agreement', 'Professional Services Agreement', 'Speaking Engagement Agreement', 'Vendor Service Agreement'],
            contract_types: [types.MULTIMEDIA, types.PERFORMANCE, types.PROF_SERVICES, types.SPEAKING_ENGAGMEMENT, types.VENDOR_SERVICES],
            multimedia_subtypes: [subtypes.MULTIMEDIA_SINGLE_USE, subtypes.MULTIMEDIA_ACADEMIC_YEAR],
            performance_subtypes: [subtypes.PERFORMANCE_SINGLE_USE, subtypes.PERFORMANCE_ACADEMIC_YEAR],
            speaker_subtypes: [subtypes.GUEST_SPEAKER_INFO, subtypes.GUEST_SPEAKER_FLAT, subtypes.GUEST_SPEAKER_REIMB],
            vendor_subtypes: [subtypes.VENDOR_SERVICE_LEVEL1_NO_INSURANCE, subtypes.VENDOR_SERVICE_REPEAT_ACADEMIC_YEAR, subtypes.VENDOR_SERVICE_SINGLE_NO_INSURANCE, subtypes.VENDOR_SERVICE_SINGLE_INSURANCE],

            speaker_less_than_600: 'y',
            speaker_reimburse: 'y',

            handle_contract: 'download_contract',
            
            email: null,
            vendor_contact_name: null,
            from_email: null,
            from_name: null,
            response_msg: null,
            display_msg: false,

            

            contract_html: null,
            
        }
    },

    mounted() {
        console.log(this.username)
        console.log(this.$route.query)

        // switch (this.$route.query.type) {
        //     case 'multimedia':
        //         this.contract.type = types.MULTIMEDIA
        //         break
            
        //     case 'performance':
        //         this.contract.type = types.PERFORMANCE
        //         break
        // }
        
        if (this.$route.query.type === 'multimedia') {
            this.contract.type = types.MULTIMEDIA
            if (this.$route.query.subtype === 'single') {
                this.contract.subtype = subtypes.MULTIMEDIA_SINGLE_USE
            }else if (this.$route.query.subtype === 'multi') {
                this.contract.subtype = subtypes.MULTIMEDIA_ACADEMIC_YEAR
            }
            this.validateStep(2, 'form1')
        }else if (this.$route.query.type === 'performance') {
            this.contract.type = types.PERFORMANCE
            if (this.$route.query.subtype === 'single') {
                this.contract.subtype = subtypes.PERFORMANCE_SINGLE_USE
            }else if (this.$route.query.subtype === 'multi') {
                this.contract.subtype = subtypes.PERFORMANCE_ACADEMIC_YEAR
            }
            this.validateStep(2, 'form1')
        }else if (this.$route.query.type === 'prof-service') {
            this.contract.type = types.PROF_SERVICES
            this.validateStep(2, 'form1')
        }
        
    },

    methods: {
        validateForm(scope) {
            return new Promise(resolve => {
                this.$validator.validateAll(scope).then((result) => {
                    if (result) {
                        resolve(true)
                    }else { 
                        resolve(false)
                    }
                })
            })
            
        },

        async validateStep(step, scope) {
            //if (this.$refs.form.validate()) {
                // const scope = scope
                console.log('Scope: ' + scope)
                console.log('Step: ' + step)
                const valid = await this.$validator.validateAll(scope).then((valid) => {
                    if (valid) {
                    
                        if (step === 3) {
                            if (this.contract.type === types.MULTIMEDIA) {
                                if (this.contract.subtype === subtypes.MULTIMEDIA_SINGLE_USE) {
                                    this.fetchContractHTML('contract-multimedia-single')

                                }
                                if (this.contract.subtype === subtypes.MULTIMEDIA_ACADEMIC_YEAR) {
                                    this.fetchContractHTML('contract-multimedia-academicyear')
                                }
                            }

                            
                            if (this.contract.type === types.PERFORMANCE) {
                                if (this.contract.subtype === subtypes.PERFORMANCE_SINGLE_USE) {
                                    this.fetchContractHTML('contract-performance-single')
                                }
                                if (this.contract.subtype === subtypes.PERFORMANCE_ACADEMIC_YEAR) {
                                    this.fetchContractHTML('contract-performance-multi')
                                }
                            }

                            if (this.contract.type === types.PROF_SERVICES) {
                                this.fetchContractHTML('contract-professional-services')
                            }

                            if (this.contract.type === types.SPEAKING_ENGAGMEMENT) {
                                if (this.speaker_less_than_600 === 'y') {
                                    this.fetchContractHTML('contract-guestspeaker-info')
                                }else {
                                    if (this.speaker_reimburse === 'n') {
                                        this.fetchContractHTML('contract-guestspeaker-flat')
                                    }
                                    if (this.speaker_reimburse === 'y') {
                                        this.fetchContractHTML('contract-guestspeaker-reimbursement')
                                    }
                                }
                                
                            }

                            if (this.contract.type === types.VENDOR_SERVICES) {
                                if (this.contract.subtype === subtypes.VENDOR_SERVICE_LEVEL1_NO_INSURANCE) {
                                    this.fetchContractHTML('contract-vendor-levelone')
                                }
                                if (this.contract.subtype === subtypes.VENDOR_SERVICE_SINGLE_NO_INSURANCE) {
                                    this.fetchContractHTML('contract-vendor-singleuse')
                                }
                                if (this.contract.subtype === subtypes.VENDOR_SERVICE_REPEAT_ACADEMIC_YEAR) {
                                    this.fetchContractHTML('contract-vendor-repeatable')
                                }
                                if (this.contract.subtype === subtypes.VENDOR_SERVICE_SINGLE_INSURANCE) {
                                    this.fetchContractHTML('contract-vendor-singleuse-insurance')
                                }
                            }
                        }

                        this.step=step
                    }
                })
                
            //}
        },

        breakDateString(dateString) {
            const newDate = new Date(dateString)
            return newDate
        },

        convertMonth(monthInt) {
            switch(monthInt) {
                case 0:
                    return 'January'
                    break
                case 1:
                    return 'February'
                    break
                case 2:
                    return 'March'
                    break
                case 3:
                    return 'April'
                    break
                case 4:
                    return 'May'
                    break
                case 5:
                    return 'June'
                    break
                case 6:
                    return 'July'
                    break
                case 7:
                    return 'August'
                    break
                case 8:
                    return 'September'
                    break
                case 9:
                    return 'October'
                    break
                case 10:
                    return 'November'
                    break
                case 11:
                    return 'December'
                    break;
                default:
                    return null
                    break
            }
        },

        fetchContractHTML(filename) {
           
                const effective = this.breakDateString(this.contract.effective_date)
                const end = this.breakDateString(this.contract.end_date)

                const performance_date_components = this.breakDateString(this.contract.performance_date)
                const service_date_components = this.breakDateString(this.contract.date_of_service)
           
            const string_replace_map = {
                '{{academicyear_enddate}}': 'August 31, 2025',
                '{{vendor_name}}': this.contract.vendor_name,
                '{{performer_name}}': this.contract.vendor_name,
                '{{vendor_address}}': this.contract.vendor_address,
                '{{vendor_rep}}': this.contract.vendor_rep,
                '{{performer_address}}': this.contract.vendor_address,
                '{{service_description}}': this.contract.description_of_service,
                '{{location}}': this.contract.location,
                '{{service_fee}}': (this.contract.fee_type === 'hourly' ? this.contract.service_fee + ' / hour' : this.contract.service_fee),
                '{{performance_title}}': this.contract.performance_name,
                '{{effective_date}}': this.contract.effective_date,
                '{{effective_day}}': effective.getUTCDate(),
                '{{effective_month}}': this.convertMonth(effective.getUTCMonth()),
                '{{effective_year}}': effective.getUTCFullYear(),
                '{{end_date}}': this.contract.end_date,
                '{{end_day}}': end.getUTCDate(),
                '{{end_month}}': this.convertMonth(end.getUTCMonth()),
                '{{end_year}}': '2025',
                '{{performance_dates}}': this.contract.performance_date,
                '{{performance_day}}': performance_date_components.getUTCDate(),
                '{{performance_month}}': this.convertMonth(performance_date_components.getUTCMonth()),
                '{{performance_year}}': performance_date_components.getFullYear(),
                '{{performance_times}}': this.contract.performance_time,
                '{{performance_length}}': this.contract.performance_length,
                '{{agent_name}}': this.contract.agent_name,
                '{{performance_fee}}': this.contract.performer_fee,
                '{{performance_type}}': this.contract.performance_type,
                '{{type_of_provider}}': this.contract.service_type,
                '{{title_of_presentation}}': this.contract.presentation_name,
                '{{speaker_audience_type}}': this.contract.speaker_audience_type,
                '{{speaker_sponsor}}': this.contract.speaker_sponsor,
                '{{speaker_duration}}': this.contract.speaker_duration,
                '{{account_number}}': this.contract.account_to_charge,
                '{{total_compensation}}': this.contract.performer_fee,
                '{{date_of_presentation}}': this.contract.performance_date,
                '{{scope_of_service}}': this.contract.description_of_service,
                '{{service_day}}': service_date_components.getUTCDate(),
                '{{service_month}}': this.convertMonth(service_date_components.getUTCMonth()),
                '{{service_year}}': service_date_components.getFullYear(),
                '{{milestones_and_key_tasks}}': this.contract.service_tasks,
                '{{key_personnel}}': this.contract.service_personnel,
                '{{acceptance_criteria}}': this.contract.service_deliverables,
                '{{service_timeline}}': this.contract.estimated_timeline,
                '{{financial_terms}}': this.contract.financial_terms,
                '{{service_date}}': this.contract.date_of_service,
                '{{contract_type}}': this.contract.type,
                '{{contract_subtype}}': this.contract.subtype

            }
            axios.get('./'+filename+'.html')
            .then(response => {
                const key_array = []
                for (let key in string_replace_map) {
                    key_array.push(key)
                }
                const keys_match = key_array.join('|')
                console.log(keys_match)
                this.contract_html = response.data
                const regex = new RegExp(keys_match, 'gi')
                this.contract_html = this.contract_html.replace(regex, function(matched) {
                    return string_replace_map[matched]
                })

            })
        },

        async sendContract (scope) {
                const self = this
                const valid = await this.$validator.validateAll(scope).then((valid) => {
                    if (valid) {
                        const to_email = this.email
                        const vendor_contact_name = this.vendor_contact_name
                        const from_email = this.from_email
                        const from_name = this.from_name
                        axios({
                            method: 'post',
                            url: './contract-wiz-auth/convert-to-pdf.php',
                            data: {
                                email: to_email,
                                vendor_contact_name: vendor_contact_name,
                                from_email: from_email,
                                from_name: from_name,
                                template: encodeURI(this.contract_html),
                                contract_type: encodeURI(this.contract.type),
                                contract_subtype: (this.contract.subtype != null ? encodeURI(this.contract.subtype) : '')
                            },
                            //responseType: 'arraybuffer',
                            headers: [
                                {'Accept': 'application/json' },
                                {'Content-Type': 'application/json'}
                            ],
                        }).then(function(response) {
                            console.log(response)
                            
                            self.response_msg = response.data.msg
                            self.display_msg = true
                            
                        })
                    }
                })
            
        },

        // For sending JSON data to PHP contract templates - See James' Comments
        downloadContractTwo() {
            axios({
                method: 'post',
                url: './contract-wiz-auth/convert-to-pdf2.php',
                data: this.contract,
                responseType: 'arrayBuffer',
                headers: {
                    'Accept': 'application/json'
                }
            }).then(function(response) {
                console.log(response)
                const blob = new Blob([response.data], {
                    type: 'application/pdf'
                })
                FileSaver.saveAs(blob, 'contract.pdf')
            })
        },

        downloadContract () {

            console.log(this.contract)
            axios({
                method: 'post',
                url: './contract-wiz-auth/convert-to-pdf.php',
                data: {
                    template: encodeURI(this.contract_html),
                    contract_type: encodeURI(this.contract.type),
                    contract_subtype: (this.contract.subtype != null ? encodeURI(this.contract.subtype) : '')
                },
                responseType: 'arraybuffer',
                headers: {
                    'Accept': 'application/json'
                }
            }).then(function(response) {
                console.log(response)
                const blob = new Blob([response.data], {
                    type: 'application/pdf'
                })
                FileSaver.saveAs(blob, 'contract.pdf')
            })
           
            // const filename = 'test_contract'
            // let pdfName = 'test_contract'
            // var doc = new jsPDF('p', 'pt', 'a4')
            
            // const margins = {
            //     top: 80,
            //     bottom: 60,
            //     left: 40,
            //     width: 500
            // }

            // doc.fromHTML(this.contract_html, margins.left, margins.top, { width: margins.width})
            
            // doc.save(pdfName + '.pdf')


        }
    }
}
</script>